/**
 * Created by Ivan on 10.08.2026
 */

const StickersCollectionWindowForTool2 = CleverappsWindow.extend({
    ctor: function (collection) {
        this.collection = collection;
        this._super();
    },

    onWindowLoaded: function () {
        this._super({
            title: `Season - ${this.collection.season}, collection - ${this.collection.index}`,
            name: "StickersCollectionWindowForTool2",
            content: this.getContent(),
            noPadding: true
        });
    },

    getContent: function () {
        const propertySource = new SeasonCollectionsHelper2(this, this.collection.season);

        const [year, seasonIndex] = this.collection.season.split("_");

        const collectionBundle = SeasonCollectionsHelper2.getCollectionBundleName(this.collection.index, this.collection.season);

        const stickersViews = [];

        let stickerIndex = 0;
        while (bundles[collectionBundle].frames[`sticker_${stickerIndex}_png`]) {
            const sticker = new cc.Sprite(bundles[collectionBundle].frames[`sticker_${stickerIndex}_png`]);

            const title = cleverapps.UI.generateOnlyText(
                Messages.get(`Sticker2.${year}.season${seasonIndex}.collection${this.collection.index}.sticker${stickerIndex}.Title`),
                cleverapps.styles.FONTS.STICKERS_COLLECTION_TEXT
            );

            title.setDimensions(sticker.width);
            sticker.addChild(title);
            title.setAlignment({
                x: { align: "center" },
                y: { align: "bottom", dy: -40 }
            });

            stickersViews.push(sticker);
            stickerIndex++;
        }

        const stickersBox = new cleverapps.GridLayout(stickersViews, {
            columns: 3,
            padding: {
                x: 20,
                y: 50
            },
            margin: {
                x: 20,
                y: 40
            }
        });

        const collectionIcon = new cc.Sprite(propertySource.getCollectionIcon(this.collection.index));
        const iconTitle = cleverapps.UI.generateOnlyText(
            Messages.get(`Collection.${year}.season${seasonIndex}.collection${this.collection.index}.Title`),
            cleverapps.styles.FONTS.STICKERS_COLLECTION_TEXT
        );

        collectionIcon.addChild(iconTitle);
        iconTitle.setAlignment({
            x: { align: "center" },
            y: { align: "bottom", dy: -40 }
        });

        return new cleverapps.Layout([
            collectionIcon,
            stickersBox
        ], {
            direction: cleverapps.UI.VERTICAL,
            margin: 20
        });
    },

    listBundles: function () {
        return [SeasonCollectionsHelper2.getCollectionBundleName(this.collection.index, this.collection.season), "stickers2_collection_window", "stickers2_book_window"];
    }
});
